<div class="jobs">
	<!-- Recomanded Jobs OR Latest Jobs-->
	<section  *ngIf="jobTitle == 'latest'">
		<div class="container">

			<h3 class="subheading flexcss"><span>{{jobsData.recommandJob ? 'Recommended Jobs':'Latest Jobs'}}
					<p class="para">Based on your profile and Search History</p>
				</span>
			</h3>
			<div class="container infinite-scroll" infinite-scroll [infiniteScrollDistance]="modalScrollDistance"
			[infiniteScrollThrottle]="modalScrollThrottle" [scrollWindow]="false" (scrolled)="onModalScrollDown()">
				<div class="row">
					<div class="col-xl-12 col-lg-12 col-md-12 col-sm-12"
						*ngFor="let job of jobsData.recommandJob || jobsData.latestJobs">
						<!-- <div *ngIf="jobsData.length > 0"> -->
						<app-applied-saved-jobs-item [job]="job" [routerLink]="'/detail/' + job?.id"
						[queryParams]="{type: 'recommanded',extras:job?.id }"
							(onJobSaved)="onJobSaved($event)"></app-applied-saved-jobs-item>
						<!-- </div> -->
					</div>
				</div>
			</div>
		</div>
	</section>
	<!-- End -->
	<div *ngIf="jobTitle == 'indus'">
		<!-- Remote jobs-->
		<section  *ngFor="let industry of jobsData.industriestList">
			<div class="container" *ngIf="industry.listing.length > 0">
				<h3 class="subheading flexcss">
					<span> {{industry.title}}
						<p *ngIf="industry.title == 'remote Jobs'" class="para">Because you expressed interest in remote
							work</p>
					</span>
				</h3>
				<div class="row">
					<div class="col-xl-12 col-lg-12 col-md-6 col-sm-12 col-12" *ngFor="let job of industry.listing">
						<!-- <div *ngIf="jobsData.length > 0"> -->
						<app-applied-saved-jobs-item [job]="job" [routerLink]="'/detail/' + job?.id"
							[queryParams]="{type: 'industry',extras:industry.industryId }"
							(onJobSaved)="onJobSaved($event)"></app-applied-saved-jobs-item>
						<!-- </div> -->
					</div>
				</div>
			</div>
		</section>
	</div>
	<!-- End -->
	<div *ngIf="jobTitle == 'roles'">
		<!-- Remote jobs-->
		<section  *ngFor="let role of jobsData">
			<div class="container" *ngIf="jobsData.length > 0">
				<h3 class="subheading flexcss">
					<span>Job Roles</span>
				</h3>
				<div class="row">
					<div class="col-xl-12 col-lg-12 col-md-6 col-sm-12 col-12" *ngFor="let role of jobsData">
						<!-- <div *ngIf="jobsData.length > 0"> -->
						<app-applied-saved-jobs-item [job]="role" [routerLink]="'/detail/' + role?.id"
							[queryParams]="{type: 'roles',extras:role.categoryId }"
							(onJobSaved)="onJobSaved($event)"></app-applied-saved-jobs-item>
						<!-- </div> -->
					</div>
				</div>
			</div>
		</section>
		<div class="noDataFound" *ngIf="jobsData?.length == 0">
			<h2>No Records Found</h2>
		</div>
	</div>
</div>